import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { GiftOrderDetailResponse } from '@models/gift';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import useCompleteAnimation from './hooks/useCompleteAnimation';
import { card, container } from './styles';

interface Props {
    response: GiftOrderDetailResponse;
}
function Complete({ response }:Props) {
    const { t } = useTranslation('gift');
    const ref = useRef<HTMLDivElement>(null);
    const cardRef = useRef<HTMLImageElement>(null);
    const imageUrl = response?.detail.giftItem.imageUrl;
    useCompleteAnimation({ ref, cardRef });
    return (
        <div className={container}
            ref={ref}>
            <CardWrapper>
                <Image src={imageUrl}
                    width={300}
                    height={200}
                    ref={cardRef}
                    className={card}
                    alt={t('giftOrderComplete.cardImageAlt')} />
            </CardWrapper>
            <Column align='center' spacing={18}>
                <Text color={colors.gray7} size='3xl' fontWeight='bold' >
                    {t('giftOrderComplete.completeMessage')}
                </Text>
            </Column>
        </div>
    );
}

const CardWrapper = styled.div`
    padding: 114px 28px 100px;
    width: 100%;
`;

export default Complete;
